import React from 'react';

/**
 * Componente para forzar visualmente las barras de seguridad en dispositivos móviles.
 * Útil para Android donde env(safe-area-inset-*) a veces retorna 0 en modo PWA/Chrome.
 */
const SafeAreaInsets = ({ top = true, bottom = true }) => {
  return (
    <>
      <style>
        {`
          .native-safe-area-top {
            display: none;
            width: 100%;
            background-color: #6348D1;
            position: sticky;
            top: 0;
            z-index: 999999;
          }
          .native-safe-area-bottom {
            display: none;
            width: 100%;
            background-color: #f4f7f6;
            position: fixed;
            bottom: 0;
            z-index: 999999;
          }

          /* Solo mostrar en móviles */
          @media (max-width: 768px) {
            .native-safe-area-top {
              display: block;
              height: max(env(safe-area-inset-top, 0px), 44px);
            }
            .native-safe-area-bottom {
              display: block;
              height: max(env(safe-area-inset-bottom, 0px), 20px);
            }
          }
        `}
      </style>
      {top && <div className="native-safe-area-top" />}
      {bottom && <div className="native-safe-area-bottom" />}
    </>
  );
};

export default SafeAreaInsets;
